import React, { useMemo, useState } from 'react';
import envConfig from '@/config/environment';
import generalConfig from '@/config/general';
import { useTrackPageViews, pageViewCounters } from '@/hooks/useTrackPageViews';
import SignUpForm from '@/components/forms/Newsletter';
import Advertisers from '@/components/head/Advertisers';
import SEO from '@/components/head/Seo';
import JsonSchemaPage from '@/components/jsonSchema/Page';
import JsonSchemaRating from '@/components/jsonSchema/Rating';
import Footer from '@/components/legal/Footer';
import PublicNav from '@/components/navigation/Public';
import ReviewsModal from '@/components/reviews/ReviewsModal';
import ChartEditor from './Editor';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const WIDGET_TAGS = ['chart-builder', 'chart'];
const PRODUCT_NAME = `${generalConfig.productName}-chart`.toLowerCase();

const ChartBuilder = _ref => {
  var _settings$jsonLd, _settings$images;

  let {
    user,
    widget,
    workbookName,
    workbookData,
    workbookMeta,
    authors,
    reviewers,
    reviews,
    settings,
    Article
  } = _ref;
  const {
    0: isViewingReviews,
    1: setIsViewingReviews
  } = useState(false);
  const reviewsScore = useMemo(() => parseFloat((reviews.reduce((acc, _ref2) => {
    let {
      score
    } = _ref2;
    return acc += score;
  }, 0) / Math.max(reviews.length, 1)).toFixed(1)), [reviews]); // Increment chart builder page view

  useTrackPageViews(pageViewCounters.chartBuilder);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(SEO, {
      title: settings.title,
      description: settings.description,
      twitterImgSrc: `${envConfig.baseUrl}${settings.images.twitterPost}`,
      ogImageSrc: `${envConfig.baseUrl}${settings.images.openGraph}`
    }), /*#__PURE__*/_jsx(Advertisers, {}), /*#__PURE__*/_jsxs(ChartEditor, {
      user: user,
      widget: widget,
      workbookName: workbookName,
      workbookData: workbookData,
      workbookMeta: workbookMeta,
      reviews: reviews,
      productName: PRODUCT_NAME,
      widgetTags: WIDGET_TAGS,
      templatesTag: settings.templatesTag,
      settings: settings,
      isCreating: true,
      isPublic: true,
      gallerySettings: {
        templatesEnabled: settings.templatesEnabled,
        dataEditorEnabled: true,
        themeEnabled: true
      },
      navigation: /*#__PURE__*/_jsx(PublicNav, {
        className: "border-b border-[#DFDFDF]"
      }),
      onReviewsClick: () => setIsViewingReviews(true),
      children: [/*#__PURE__*/_jsx(Article, {
        createdAt: settings.createdAt,
        updatedAt: settings.updatedAt,
        authors: authors,
        reviewers: reviewers
      }), /*#__PURE__*/_jsx(SignUpForm, {}), /*#__PURE__*/_jsx(Footer, {})]
    }), /*#__PURE__*/_jsx(ReviewsModal, {
      isVisible: isViewingReviews,
      reviews: reviews,
      cta: "Add Your Review",
      onClose: () => setIsViewingReviews(false)
    }), /*#__PURE__*/_jsx(JsonSchemaPage, {
      headline: settings.title,
      url: `/${settings.slug}` // @ts-ignore
      ,
      type: settings === null || settings === void 0 ? void 0 : (_settings$jsonLd = settings.jsonLd) === null || _settings$jsonLd === void 0 ? void 0 : _settings$jsonLd.type,
      createdAt: settings.createdAt,
      updatedAt: settings.updatedAt,
      imgSrc: settings === null || settings === void 0 ? void 0 : (_settings$images = settings.images) === null || _settings$images === void 0 ? void 0 : _settings$images.resourceUrl,
      imgWidth: 768,
      imgHeight: 768,
      authors: authors,
      editors: reviewers
    }), reviews && reviews.length ? /*#__PURE__*/_jsx(JsonSchemaRating, {
      name: settings.heading,
      description: settings.description,
      ratingCount: reviews.length,
      ratingValue: reviewsScore
    }) : /*#__PURE__*/_jsx(_Fragment, {})]
  });
};

export default ChartBuilder;